import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

interface SentryUserParams {
  userId?: string;
  email?: string;
}

export function useSentryUser({ userId, email }: SentryUserParams) {
  useEffect(() => {
    if (userId) {
      Sentry.setUser({ id: userId, email });
    } else {
      Sentry.setUser(null);
    }
  }, [userId, email]);
}
